export type NominatimResponse = {
  lat: number;
  lng: number;
  location: string;
  apiResponse: any;
};
